import { PublicClientApplication, LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
clientId: "bf1eec8e-a3e1-4682-b538-08c5a3f3f951",
authority: "https://login.microsoftonline.com/7a6b513b-ac22-48af-a649-b1155af50b2d",
    // Use the current origin so the same build works on prod, the staging SWA, and
    // local dev. Every origin must be registered as a SPA redirect URI on the app
    // registration (bf1eec8e…) in Entra.
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage", // Keeps user signed in across sessions
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error(message);
      },
    },
  },
};

// Scopes for Microsoft Graph (get user profile)
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

// Scope for the Ops Hub API itself. A token for THIS scope (audience) is what the
// backend verifies — distinct from the Graph token above. Exposed on app
// registration bf1eec8e… as "Expose an API" → access_as_user (see docs/manual-steps.md).
export const apiTokenRequest = {
  scopes: ["api://bf1eec8e-a3e1-4682-b538-08c5a3f3f951/access_as_user"],
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before rendering
export async function initializeMsal() {
  await msalInstance.initialize();
  // Handle redirect response (if returning from login)
  const response = await msalInstance.handleRedirectPromise();
  if (response) {
    msalInstance.setActiveAccount(response.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
  return msalInstance;
}
